export default function DriveFileRenameIcon(props) {
  const { className, onClick } = props;
  return (
    <svg className={className} onClick={onClick} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.41 5.80086L17.2 4.59086C16.42 3.81086 15.15 3.81086 14.37 4.59086L11.69 7.27086L3 15.9609V20.0009H7.04L15.78 11.2609L18.41 8.63086C19.2 7.85086 19.2 6.58086 18.41 5.80086ZM6.21 18.0009H5V16.7909L13.66 8.13086L14.87 9.34086L6.21 18.0009ZM11 20.0009L15 16.0009H21V20.0009H11Z" />
    </svg>
  );
}
